// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.note-modal-header {
  --background: var(--ion-color-light);
}

.note-form {
  padding: 16px;
}

.note-textarea {
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin: 16px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.cancel-btn {
  --color: var(--ion-color-medium);
}

.confirm-btn {
  --color: var(--ion-color-primary);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/modals/note/note.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;AACJ;;AAIE;EACE,aAAA;AADJ;;AAIE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,wCAAA;AADJ;;AAIE;EACE,gCAAA;AADJ;;AAIE;EACE,iCAAA;EACA,gBAAA;AADJ","sourcesContent":[".note-modal-header {\r\n    --background: var(--ion-color-light);\r\n  }\r\n\r\n\r\n\r\n  .note-form {\r\n    padding: 16px;\r\n  }\r\n\r\n  .note-textarea {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 12px;\r\n    margin: 16px 0;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .cancel-btn {\r\n    --color: var(--ion-color-medium);\r\n  }\r\n\r\n  .confirm-btn {\r\n    --color: var(--ion-color-primary);\r\n    font-weight: 500;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
